import styled from '@emotion/styled'
import Slider from '../Slider'

const StyledSlider = styled(Slider)`
  width: 100%;
`

const Scrubber = ({ className, duration, onScrub, onScrubEnd, progress }) => {
  return (
    <div className={className}>
      <StyledSlider
        type="range"
        min="0"
        max={duration ? duration : `${duration}`}
        step="1"
        value={progress}
        id="myRange"
        onChange={(e) => onScrub(e.target.value)}
        onKeyUp={onScrubEnd}
        onMouseUp={onScrubEnd}
        onTouchEnd={onScrubEnd}
      />
    </div>
  )
}

export default Scrubber
